import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://rykvptiauiwwdgexstav.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ5a3ZwdGlhdWl3d2RnZXhzdGF2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE0ODU2NjcsImV4cCI6MjA3NzA2MTY2N30.Cfpm37SBdyM7IaPaywLsNQDpZ-Lm3bYuhOH_Zi9tDBw'

export const supabase = createClient(supabaseUrl, supabaseKey)

// Получаем баланс пользователя
export async function getBalance(telegram_id) {
  const { data, error } = await supabase
    .from('tgusers')
    .select('balance')
    .eq('telegram_id', Number(telegram_id))
    .single()

  if (error) {
    console.error('Error fetching balance:', error)
    return null
  }

  return data?.balance ?? 0
}

// Создаём пользователя, если его нет
export async function createUser(telegram_id, referred_by = null) {
  const userData = { 
    telegram_id: Number(telegram_id), 
    balance: 0 
  };
  
  // Add referral information if provided
  if (referred_by) {
    userData.referred_by = Number(referred_by);
  }
  
  const { data, error } = await supabase
    .from('tgusers')
    .insert([userData])
    .select()

  if (error) {
    console.error('Error creating user:', error)
    return null
  }

  return data
}

// Обновляем баланс пользователя
export async function updateBalance(telegram_id, newBalance) {
  const { data, error } = await supabase
    .from('tgusers')
    .update({ balance: newBalance, last_updated: new Date() })
    .eq('telegram_id', Number(telegram_id))
    .select()

  if (error) {
    console.error('Error updating balance:', error)
    return null
  }

  return data
}

// Получаем информацию о пользователе
export async function getUserInfo(telegram_id) {
  const { data, error } = await supabase
    .from('tgusers')
    .select('*')
    .eq('telegram_id', Number(telegram_id))
    .single()

  if (error) {
    console.error('Error fetching user info:', error)
    return null
  }

  return data
}

// Получаем количество рефералов
export async function getReferralCount(telegram_id) {
  const { count, error } = await supabase
    .from('tgusers')
    .select('*', { count: 'exact', head: true })
    .eq('referred_by', Number(telegram_id))

  if (error) {
    console.error('Error fetching referral count:', error)
    return 0
  }

  return count || 0
}